var map = {
	"./en": [
		"5848"
	],
	"./en.json": [
		"5848"
	],
	"./es": [
		"dc65",
		"lang-es~9f1ce398"
	],
	"./es.json": [
		"dc65",
		"lang-es~9f1ce398"
	],
	"./pt": [
		"3854",
		"lang-pt~93b340ce"
	],
	"./pt.json": [
		"3854",
		"lang-pt~93b340ce"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9e08";
module.exports = webpackAsyncContext;